import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Measurement } from '@usimweb/core/models';
import { PlotLayout } from '@usimweb/core/services';
import { PlotlyService } from 'angular-plotly.js';

@Component({
    selector: 'app-measurement-data-chart',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './measurement-data-chart.component.html',
    styleUrls: ['./measurement-data-chart.component.scss'],
    standalone: false
})
export class MeasurementDataChartComponent extends PlotLayout implements OnInit {
  @Input() measurements: Measurement[] = [];

  public data: Measurement[] = [];

  constructor(public override snackBar: MatSnackBar, public override plotlyService: PlotlyService) {
    super(plotlyService, snackBar);
    this.onInitialized();
  }

  ngOnInit(): void {
    this.densityViscoLayout.width = 900;
    this.densityViscoLayout.height = 500;
    this.addCurves(this.measurements);
  }
}
